import React from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core'
import FavoriteIcon from '@material-ui/icons/Favorite'
import IconButton from '@material-ui/core/IconButton'
import { isUserLogged } from 'utils'
import get from 'lodash.get'
import offIcon from 'icons/off.svg'
import { MESSAGE } from '../../../constants'

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  iconButton: {
    width: 'auto',
    height: 'auto',
    color: 'inherit',
    padding: '0px',
  },
  filledIcon: {
    color: '#d24c4c',
  },
  emptyIcon: {
    height: 'auto',
  },
  label: {
    padding: '10px',
  },
  withLabel: {
    color: '#ffffff',
  },
}

const Favorite = props => {
  const { classes, user, propertyId, showFlashMessage, addPropertyToFavorites, removePropertyFromFavorites, withLabel } = props

  const isFavorited = isUserLogged(user) && get(user, 'favorites', []).includes(propertyId)

  const handleClick = evt => {
    evt.preventDefault()
    evt.stopPropagation()
    if (!isUserLogged(user)) {
      showFlashMessage(false, MESSAGE.LOGIN_ERROR_MESSAGE)
    } else {
      !isFavorited ? addPropertyToFavorites(propertyId, user) : removePropertyFromFavorites(propertyId, user)
    }
  }

  return (
    <div className={`${classes.root} ${classes.withLabel}`}>
      <IconButton disableRipple={true} className={classes.iconButton} onClick={handleClick}>
        {!isFavorited ? (
          <img src={offIcon} className={classes.emptyIcon} alt="off" />
        ) : (
          <FavoriteIcon style={{ fontSize: 27 }} className={classes.filledIcon} />
        )}
      </IconButton>
      {withLabel && !isFavorited && <span className={classes.label}>ADD TO FAVORITE</span>}
    </div>
  )
}

Favorite.propTypes = {
  withLabel: PropTypes.bool,
  addPropertyToFavorites: PropTypes.func.isRequired,
  removePropertyFromFavorites: PropTypes.func.isRequired,
  showFlashMessage: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  propertyId: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
}

Favorite.defaultProps = {
  withLabel: false,
}

export default withStyles(styles)(Favorite)



// WEBPACK FOOTER //
// ./src/features/favorites/components/Favorite.js